Object.defineProperty(exports, "__esModule", { value: true });
exports.getNcssSwitch = void 0;
exports.getNcssSwitch = (style, switchName) => {
    const emptyNcss = { ncss: {} };
    if (!style) {
        console.log(`WARNING: getNcssSwitch: style has no value`);
        return emptyNcss;
    }
    if (!switchName) {
        console.log(`WARNING: getNcssSwitch: switchName has no value`);
        return emptyNcss;
    }
    if (!style.ncssSwitch) {
        console.log(`WARNING: style.ncssSwitch has no value`);
        return emptyNcss;
    }
    if (switchName in style.ncssSwitch) {
        return { ncss: style.ncssSwitch[switchName] };
    }
    console.log(`WARNING: getNcssSwitch: switchName '${switchName}' not found in style.ncssSwitch `);
    return emptyNcss;
};
//# sourceMappingURL=ncss.js.map